module.exports = __webpack_public_path__ + "img/img8.91d2e58e.svg";